export const html:string = `
<div class="image-shadow">
    <div id="img-shadow-container" style="height: 100%;">
        <img v-bind:src="image" :style="{filter: shadow}" :class="{ 'inverted-img' : invert }">
    </div>
</div>
`;